import React from 'react';
import { observer } from 'mobx-react';
import { SearchGameItemBox } from './boxes/search-game-item/search-game-item.box';
import { ISearchSuggestion } from '../../../../services/game-search/game-search-result';
import { GameImageComponent } from '../../../single-game/common/parts/game-image/game-image.component';
import { HighlightSearchListItemComponent } from '../highlight-search-list-item/highlight-search-list-item.component';
import { SearchTextWrapperBox } from './boxes/search-text-wrapper/search-text-wrapper.box';
import {SearchGameImageBox} from "./boxes/search-game-image-box/search-game-image.box";
import {ComponentServicesPick} from "../../../../services/component-services-pick";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {withServices} from "../../../../react-hooks/with-services";


export interface SearchGameItemComponentProps extends ComponentServicesPick<'sideMenu' | 'gameSearch'>{
    searchSuggestion: ISearchSuggestion;
}

const ComponentBody: React.FC<SearchGameItemComponentProps> = observer((props) => {
    const services = useServices();
    const _onClickHandler = async () => {
        await props.gameSearch.closeSearchResult();
        (await services.userMenu).closeMenu();
        await props.sideMenu.closeMobileMenu();
        await props.searchSuggestion.executeAction();
    };

    return (
        <SearchGameItemBox className={'cy-search-game-item'} onClick={_onClickHandler}>
            <SearchGameImageBox>
                <GameImageComponent gameInfo={props.searchSuggestion.gameInfo} useLazyLoading={false}/>
            </SearchGameImageBox>
            <SearchTextWrapperBox>
                <HighlightSearchListItemComponent nameOfTheGame={props.searchSuggestion.text} />
            </SearchTextWrapperBox>
        </SearchGameItemBox>
    );
})

export const SearchGameItemComponent = withServices(ComponentBody, ['sideMenu', 'gameSearch']);
